/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type labelCreateMutationVariables = {|
  id: string,
  labels?: ?$ReadOnlyArray<?string>,
|};
export type labelCreateMutationResponse = {|
  +recipeLabelCreate: ?{|
    +recipeLabels: ?$ReadOnlyArray<?{|
      +id: string
    |}>
  |}
|};
export type labelCreateMutation = {|
  variables: labelCreateMutationVariables,
  response: labelCreateMutationResponse,
|};
*/


/*
mutation labelCreateMutation(
  $id: ID!
  $labels: [ID]
) {
  recipeLabelCreate(input: {recipe: $id, labels: $labels}) {
    recipeLabels {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labels",
    "type": "[ID]"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "labels",
            "variableName": "labels"
          },
          {
            "kind": "Variable",
            "name": "recipe",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeAddLabelPayload",
    "kind": "LinkedField",
    "name": "recipeLabelCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeLabelNode",
        "kind": "LinkedField",
        "name": "recipeLabels",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "labelCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "labelCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "labelCreateMutation",
    "operationKind": "mutation",
    "text": "mutation labelCreateMutation(\n  $id: ID!\n  $labels: [ID]\n) {\n  recipeLabelCreate(input: {recipe: $id, labels: $labels}) {\n    recipeLabels {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9c9f875978e40577d9427fa8fe64ddd0';

module.exports = node;
